angular.module('impactx.address').controller('BasketAddressDialogCtrl', [
    '$mdDialog',
    'dataGen',
    BasketAddressDialogController
]);

function BasketAddressDialogController($mdDialog, dataGen) {
    var self = this;
    self.requestInProgress = false;
    self.addresses = angular.copy(self.addresses);

    self.title = self.trns.addresses;
    self.additionalData = null;
    if(self.bksId) {
        self.title = self.trns.addressesForBKS;
        self.additionalData = { bksId: self.bksId};
    }
    if(self.bkiId) {
        self.title = self.trns.addressesForBKI;
        self.additionalData = { bkiId: self.bkiId};
    }

    getAddresses().then(function (addresses) {
        self.addresses = addresses;
    });

    self.apply = function () {
        $mdDialog.hide(self.addresses);
    };

    self.abort = function () {
        $mdDialog.cancel();
    };

    function getAddresses() {
        self.requestInProgress = true;
        return dataGen.getData({}, {
            bksId: self.bksId,
            bkiId: self.bkiId
        }, '/basket/input/addresses').then(function (response) {
            self.requestInProgress = false;
            return impactX.isDefined(response, 'data');
        });
    }
}